import { render } from "./AutoScaleLoadBalancing.vue?vue&type=template&id=0b01faf9&scoped=true"
import script from "./AutoScaleLoadBalancing.vue?vue&type=script&lang=js"
export * from "./AutoScaleLoadBalancing.vue?vue&type=script&lang=js"

import "./AutoScaleLoadBalancing.vue?vue&type=style&index=0&id=0b01faf9&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b01faf9"]])

export default __exports__